import createReactClass from 'create-react-class';
// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Import JS Modules
import genericHelpers from '../../_utils/generic-helpers';
import screenAndStyle from '../../_utils/screen-and-style';
// Import JSX Modules
import FullScreenSpinner from '../../_prism-builder/desktop/notices/full-screen-spinner';
import SiteLogo from '../../_application/site-logo';
import Login from '../../_application/login';
import AddPhotosDevice from '../common/add-photos-device';
import PhotosList from './photos-list';
import Totaliser from '../common/totalizer';
import AddToCartControls from '../common/add-to-cart-controls';
import UploadProgressBar from '../common/upload-progress-bar';
import Options from './options';
import InvalidSizesModal from '../common/invalid-sizes-modal';
import InvalidDeliveryOptionModal from '../common/invalid-delivery-option-modal';
import PhotoRemoveConfirmation from '../common/photo-remove-confirmation';
import SizeHelpers from '../common/size-helpers';
import PrintsBuilderMixin from '../common/prints-builder-mixin';
import UploadPhotosMixin from '../common/upload-photos-mixin';
import PricingChartPopup from './pricing-chart-popup';
import BulkQuantityChange from '../common/bulk-quantity-change';
import SummaryChart from './summary-chart';
import LoadingPhotoPlaceholders from './loading-photo-placeholders';
import AdvancedEditor from '../common/advanced-editor';
import PrintFinishTabs from '../common/print_finish_tabs';
import { PrintsBuilderUrlsShape } from '../prop-types';

// -----------------------------------------------------------
//  Controller
// -----------------------------------------------------------
const PrintsBuilder = createReactClass({
  mixins: [PrintsBuilderMixin, UploadPhotosMixin],
  displayName: 'PrintsBuilder',
  desktop: true,
  getInitialState() {
    return {
      finish: {},
      delivery_option: {},
      sizes: [],
      currentlyLoading: undefined,
      invalidDeliveryOptionSelected: false,
    };
  },

  UNSAFE_componentWillMount() {
    this.loadData();
    this.loadCallbacks();

    this._forceUpdate = genericHelpers.debounce(() => this.forceUpdate());

    $(window).on('resize orientationchange', this._forceUpdate);
  },

  componentDidMount() {
    document.body.classList.add('disable-focus-styles');
    window.addEventListener('keydown', this.handleKeyPress);
  },

  componentWillUnmount() {
    this.unloadCallbacks();

    $(window).off('resize orientationchange', this._forceUpdate);
    window.removeEventListener('keydown', this.handleKeyPress, false);
  },

  render() {
    const availableSizes = this.availableSizesForSelectedDeliveryAndFinish();
    const { sizes, invalidDeliveryOptionSelected } = this.state;

    const $pricingChartPopup = (({ pricesPopup }, { ready, sizes }) => {
      if (pricesPopup && ready) {
        return (
          <PricingChartPopup
            products={sizes}
            finishes={this.data.finishes}
            deliveryOptions={this.data.delivery_options}
          />
        );
      }
    })(window.features, this.state);

    const hasPhotos = this.hasPhotos();
    const sizesByFinish = this.getSizesByFinish();
    const { currentlyLoading } = this.state;
    const {
      features: { pricesPopup, allowMultiplePrintFinishesPerOrder },
    } = window;

    return (
      <div
        className={classNames('prints-builder__grid desktop', {
          'is-touch': screenAndStyle.isTouch(),
        })}>
        <header className="prints-builder__header d-flex align-items-center">
          <div className="flex-grow-1">
            <SiteLogo />
          </div>
          <div className="flex-shrink-0 d-flex align-items-center justify-content-end h-100">
            <Login />
            <Totaliser
              sizes={sizes}
              deliveryOption={this.state.delivery_option}
            />
            <AddToCartControls
              enabled={this.hasPrints() && !currentlyLoading}
              basketUrl={this.props.urls.cart_page}
              onAddToCart={this.handleAddToCart}
            />
          </div>
        </header>
        <main className="prints-builder__list d-flex flex-column position-relative">
          {allowMultiplePrintFinishesPerOrder && (
            <PrintFinishTabs
              finishes={[...this.data.finishes]}
              selectedFinish={this.state.finish}
            />
          )}
          <div className="grey-zone flex-shrink-0">
            <BulkQuantityChange
              availableSizes={availableSizes}
              sizes={sizes}
              photos={this.allPhotos()}
              deliveryOption={this.state.delivery_option}
              disabled={!hasPhotos || !!currentlyLoading}
              onChange={this.handleQuantityChanged}
            />
          </div>
          <UploadProgressBar {...currentlyLoading} />
          <div className="list-view">
            {!!currentlyLoading && (
              <LoadingPhotoPlaceholders {...currentlyLoading} />
            )}
            {hasPhotos && (
              <PhotosList
                availableSizes={availableSizes}
                sizes={sizesByFinish}
                finish={this.state.finish}
                deliveryOption={this.state.delivery_option}
                showPricesPopup={pricesPopup}
                disabled={!!currentlyLoading}
                onQuantityChanged={this.handleQuantityChanged}
              />
            )}
            {!this.hasPhotosForSelectedFinish() && !currentlyLoading && (
              <AddPhotosDevice onClick={this.handleAddPhotos} />
            )}
          </div>
        </main>
        <aside className="prints-builder__side-bar d-flex flex-column grey-zone">
          <Options
            availableSizes={availableSizes}
            deliveryOptions={[...this.data.delivery_options]}
            deliveryOption={this.state.delivery_option}
            finishesByDeliveryOption={Object.assign(
              {},
              this.availableFinishesByDeliveryOption
            )}
            finishes={[...this.data.finishes]}
            finish={this.state.finish}
            showAllPricesLink={!!pricesPopup}
            hidePrintFinishes={!!allowMultiplePrintFinishesPerOrder}
            onChange={this.handleOptionsChanged}
            onQuantityChanged={this.handleQuantityChanged}
          />
          <SummaryChart
            className="flex-grow-1"
            sizes={sizes}
            deliveryOption={this.state.delivery_option}
          />
          <button
            ref={ref => (this.addPhotosButtonRef = ref)}
            className="btn btn-outline-secondary add-photos"
            role="button"
            onClick={this.handleAddPhotos}
            disabled={!!currentlyLoading || invalidDeliveryOptionSelected}>
            Add {hasPhotos ? 'More' : ''} Photos
          </button>
        </aside>
        <AdvancedEditor
          ref={ref => (this.advancedEditorRef = ref)}
          availableSizes={availableSizes}
          onQuantityChanged={this.handleAdvancedPhotoQuantityChanged}
        />
        <PhotoRemoveConfirmation />
        {$pricingChartPopup}
        <InvalidSizesModal />
        <InvalidDeliveryOptionModal />
        <FullScreenSpinner show={!this.state.ready} />
      </div>
    );
  },
  handleAdvancedEdit(rootImageId, selectedSizeKey, isLastPhoto) {
    // Retrieve the photo with the selectedSizeKey
    const photo = this.state.sizes
      .filter(size => size.photos.length)
      .reduce((photo, size) => {
        const relevantPhoto = this.getPhoto(size, rootImageId, true);
        if (relevantPhoto && relevantPhoto.quantity) {
          const tmpPhoto = SizeHelpers.augment.individual(relevantPhoto, size);
          if (tmpPhoto.size.key == selectedSizeKey) {
            photo = tmpPhoto;
          }
        }
        if (photo) photo.isLastPhoto = isLastPhoto;
        return photo;
      }, undefined);

    this.advanced_edit = {
      size: photo.size,
      photo: photo,
    };

    this.advancedEditor().setData({
      photo: photo,
      availableSizes: this.availableSizesForSelectedDeliveryAndFinish(),
      sizes: [...this.state.sizes],
    });
  },
  refreshEL2(sizeKey, imageId) {
    if (this.advanced_edit) {
      const size = this.getSizeFromKey(sizeKey),
        photo = this.getPhoto(size, imageId);

      this.handleAdvancedEdit(photo.root_image_id, sizeKey);
    }
  },
  allowZeroQuantity() {
    return true;
  },

  handleKeyPress(event) {
    if (event.keyCode === 9) {
      document.body.classList.remove('disable-focus-styles');
    }
  },
});

PrintsBuilder.propTypes = {
  urls: PrintsBuilderUrlsShape.isRequired,
  features: PropTypes.object,
  uploadFromGalleryListenerUrl: PropTypes.string,
};

export default PrintsBuilder;
